import { EventEmitter } from '@angular/core';
var ToolbarTitleComponent = /** @class */ (function () {
    function ToolbarTitleComponent() {
        this.switchView = new EventEmitter();
        this.viewInfo = new EventEmitter();
    }
    return ToolbarTitleComponent;
}());
export { ToolbarTitleComponent };
